(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-purchase-extras"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dispatch-clock]').forEach((clock) => {
    const clockText = clock.querySelector('[data-dispatch-clock-text]');
    const cutoffHour = Number(clock.dataset.cutoffHour || 18);
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const updateClock = () => {
      const parts = Object.fromEntries(
        formatter.formatToParts(new Date()).map((part) => [part.type, part.value])
      );
      const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
      const currentSeconds = (Number(parts.hour) * 3600) + (Number(parts.minute) * 60) + Number(parts.second);
      const remainingSeconds = (cutoffHour * 3600) - currentSeconds;

      if (weekdays.includes(parts.weekday) && remainingSeconds > 0) {
        const hours = Math.floor(remainingSeconds / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;
        const time = hours > 0 ? `${hours}h ${minutes}m ${seconds}s` : `${minutes}m ${seconds}s`;
        clockText.textContent = clock.dataset.countdownTemplate.replace('__TIME__', time);
        return;
      }

      if (parts.weekday === 'Fri' || parts.weekday === 'Sat' || parts.weekday === 'Sun') {
        clockText.textContent = clock.dataset.dispatchMonday;
        return;
      }

      clockText.textContent = clock.dataset.nextWorkingDay;
    };

    updateClock();
    window.setInterval(updateClock, 1000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-cart"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-sticky-cart').forEach((stickyCart) => {
    const trigger = document.querySelector('.product-tabs') || document.querySelector('[data-section-type="product"]');
    if (!trigger) return;

    let ticking = false;
    const updateStickyCart = () => {
      const shouldShow = trigger.getBoundingClientRect().bottom <= 0;
      stickyCart.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('product-sticky-cart-visible', shouldShow);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStickyCart);
    };

    updateStickyCart();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  });
  } catch(e) { console.error(e); }
})();

})();
